import { Component, OnInit, Query, Output, EventEmitter, Injector, ViewChild } from '@angular/core';

import { AppComponentBase } from "../../../../../shared/common/app-component-base";

import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent extends AppComponentBase {

    @ViewChild('myappBaseModal', { static: true }) mymodal: ModalDirective;
    @Output() onConfirmation: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    expectedText:string;
    enteredText: string ="";
    correct:boolean=false;
    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(expectedValue: string): void {
        this.active = true;
        this.expectedText = expectedValue;
        this.mymodal.show();
    }

    close(): void {
        this.active = false;
        this.mymodal.hide();
    }
    onConfirmClick(): void {
        this.close();
        this.onConfirmation.emit();
    }
    onCancelClick(): void {
        this.close();
        this.onCancel.emit();
    }

    checkName(value:string) {
        if (this.enteredText === this.expectedText) {
            this.correct = true;
        } else {
            this.correct = false;
        }
    }
}
